import { Expandable } from '@warp-ds/react';

type Props = {
    question: string;
    answer: string[];
};

const ExpandableQuestion = ({ question, answer }: Props) => (
    <div className="py-4 w-full">
        <Expandable style={{ backgroundColor: '#FFF3F7' }} title={<p className="py-8 mb-0 font-bold text-s">{question}</p>} box>
            {answer.map((paragraph, index) => (
                <p key={`${index}-${paragraph.slice(0, 10)}`}>{paragraph}</p>
            ))}
        </Expandable>
    </div>
);

export default ExpandableQuestion;
